import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "components";
import { deleteApi, getApi, patchApi, postApi } from "lib";
import {
  ADDRESS,
  ADD_MEMBER,
  CART,
  PATCH_USER_DETAILS,
  USER_DETAILS,
} from "services";
import { API_ERROR } from "utils/constant";

// Several pages build an address save payload from a form that still carries
// flat customer_lat/customer_long fields (left over from the map picker).
// The API expects neither of those — it wants current_location as a list of
// { latitude, longitude } dicts — so normalize every address write here,
// once, instead of relying on each page to strip/reshape it correctly.
const normalizeAddressPayload = (data) => {
  const { customer_lat, customer_long, current_location, ...rest } = data || {};

  const firstLocation = Array.isArray(current_location) ? current_location[0] : current_location;
  const latitude = firstLocation?.latitude ?? Number(customer_lat);
  const longitude = firstLocation?.longitude ?? Number(customer_long);

  return {
    ...rest,
    current_location: Number.isFinite(latitude) && Number.isFinite(longitude) ? [{ latitude, longitude }] : [],
  };
};

export const getAddresses = createAsyncThunk(
  "user/getAddresses",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(ADDRESS);
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const postAddress = createAsyncThunk(
  "user/postAddress",
  async ({ data, next }, thunkAPI) => {
    try {
      const response = await postApi(ADDRESS, normalizeAddressPayload(data));
      if (response?.data?.success) {
        next(response?.data?.data);
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const deleteAddress = createAsyncThunk(
  "user/deleteAddress",
  async ({ id, next }, thunkAPI) => {
    try {
      const response = await deleteApi(ADDRESS + "?address_id=" + id);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const patchAddress = createAsyncThunk(
  "user/patchAddress",
  async ({ data, next = () => {} }, thunkAPI) => {
    try {
      const response = await patchApi(ADDRESS, normalizeAddressPayload(data));
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getUserDetails = createAsyncThunk(
  "user/getUserDetails",
  async (payload, thunkAPI) => {
    if (payload) {
      try {
        const response = await getApi(USER_DETAILS + "healon");
        if (response?.data?.success) {
          return response?.data?.data;
        }
      } catch (error) {
        message.error(error?.response?.data?.message || API_ERROR);
        return thunkAPI.rejectWithValue(error.response.data.message);
      }
    }
  }
);
export const patchUserDetails = createAsyncThunk(
  "user/patchUserDetails",
  async ({ data, next = () => {} }, thunkAPI) => {
    try {
      const response = await patchApi(PATCH_USER_DETAILS, data);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const postMember = createAsyncThunk(
  "user/postMember",
  async ({ data, next = () => {} }, thunkAPI) => {
    try {
      const response = await postApi(ADD_MEMBER, data);
      if (response?.data?.success) {
        next(response?.data?.data);
        // message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getMembers = createAsyncThunk(
  "user/getMembers",
  async (_, thunkAPI) => {
    try {
      const response = await getApi(ADD_MEMBER);
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const deleteMembers = createAsyncThunk(
  "user/deleteMembers",
  async ({ id, next }, thunkAPI) => {
    try {
      const response = await deleteApi(ADD_MEMBER + "?member_id=" + id);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const patchMember = createAsyncThunk(
  "user/patchMember",
  async ({ data, next = () => {} }, thunkAPI) => {
    try {
      const response = await patchApi(ADD_MEMBER, data);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
